<template>
	<div>
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Edit Client</h1>
                <div @click="hideModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <form class="p-5 max-w-lg">
                <div class="p-4 grid grid-cols-3 gap-6 bg-gray-100 border border-gray-300 rounded-sm shadow-md ">
                    <div class="col-span-3 flex flex-col">
                        <label class="text-base" for="name">Name</label>
                        <input v-model="client.name" type="text" class="form-input w-full">
                        <div v-if="errors.name" class="form-error">{{ errors.name[0] }}</div>
                    </div>

                    <div class="col-span-3 flex flex-col">
                        <label class="text-base" for="address">Address</label>
                        <input v-model="client.address" type="text" class="form-input w-full">
                        <div v-if="errors.address" class="form-error">{{ errors.address[0] }}</div>
                    </div>

                    <div class="flex flex-col">
                        <label class="text-base" for="city">City</label>
                        <input v-model="client.city" type="text" class="form-input">
                        <div v-if="errors.city" class="form-error">{{ errors.city[0] }}</div>
                    </div>

                    <div class="flex flex-col">
                        <label class="text-base" for="state">State</label>
                        <select v-model="client.state" class="mt-0 form-select">
                            <option value=""></option>
                            <option v-for="(state, stateIndex) in states" :key="stateIndex" :value="state.state">{{ state.state }}</option>
                        </select>
                        <div v-if="errors.state" class="form-error">{{ errors.state[0] }}</div>
                    </div>

                    <div class="flex flex-col">
                        <label class="text-base" for="postal_code">Postal Code</label>
                        <input v-model="client.postal_code" type="text" class="form-input">
                        <div v-if="errors.postal_code" class="form-error">{{ errors.postal_code[0] }}</div>
                    </div>

                    <div class="col-span-3 flex flex-col">
                        <label class="text-base" for="country">Country</label>
                        <select v-model="client.country_id" class="form-select">
                            <option value=""></option>
                            <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
                        </select>
                        <div v-if="errors.country_id" class="form-error">{{ errors.country_id[0] }}</div>
                    </div>
                </div>
            </form>
            <div class="bg-gray-100 p-4">
                <div class="text-right">
					<button class="btn btn-secondary mr-2" @click.prevent="hideModal">Close</button>
					<button class="btn btn-green" @click.prevent="save">Save Client</button>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

    export default {
        props: ['clientId'],

        data() {
            return {
            	client: '',
                countries: {},
                states: {},
            	errors: {}
            }
        },

        created() {
        	this.client = _.clone(_.find(this.clients.all, (client) => client.id == this.clientId));
        },

        mounted() {
            axios.get('/api/address-info').then((response) => {
                this.countries = response.data.countries;
                this.states = response.data.states;
            }).catch((error) => {
                console.log(error);
            });
        },

        computed: {
        	...mapState(['clients']),
        },

        methods: {
            async save() {
				axios.patch('/clients/' + this.client.id, this.client).then(response => {
					this.client = response.data.client;
                	this.$emit('client-updated', response.data.client);

					this.$notify({
						type: 'success',
						title: 'Success',
						text: response.data.message
					});

					this.hideModal();
                }).catch(error => {
					this.$notify({
						type: 'error',
						title: 'Error',
						text: error.response.data.message
					});
                });
            },
        }
    }
</script>
